<div
    class="w-full score-box {{ getClaimActions(claim)[claim.status].scoreBoxClass }}"
    style="padding: 24px; background: white; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex"
>
    <div
        style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
        <div
            style="align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
            <div
                class="typography-title-m"
                style="align-self: stretch; color: #323232; font-size: 20px; font-family: Diagramm; font-weight: 500; line-height: 24px; word-wrap: break-word"
            >
                {{ 'my_claims.score_box.status' | translate }}: {{ claim.statusi18nkey || '' | translate }}
            </div>
        </div>
    </div>
    <div class="divider my-4 w-full"></div>
    <span class="typography-body-l-regular" style="align-self: stretch; color: #323232; word-wrap: break-word">
        {{ getClaimActions(claim)[claim.status].description || '' | translate }}
    </span>
    <span *ngIf="claim.statusComment && (claim.status === 'DENIED' || claim.status === 'APPROVED')" class="typography-body-l-medium">
        {{ claim.statusComment }}
    </span>
    <div *ngIf="claim.statusi18nkey === 'my_claims.pending_information' && currentTab !== 'COMMENTS'"
        style="align-self: stretch; flex-direction: column; justify-content: center; align-items: center; gap: 8px; display: flex">
        <app-button (click)="onGoToComments.emit()" [style]="{ width: '100%' }" [primary]="true" [block]="true">
            <div class="typography-body-m-medium"
                 style="text-align: center; word-wrap: break-word">{{ 'my_claims.show_message' | translate }}
            </div>
        </app-button>
    </div>
    <div *ngIf="claim.statusi18nkey === 'my_claims.denied'" class="flex flex-col w-full">
        <div class="divider my-4 w-full"></div>
        <span>{{ 'my_claims.if_you_need_to_make_a_consult_talk_to_your_manager' | translate }}</span>
    </div>
</div>
